import * as mutations from './mutations'

/* example of form model:
form: {
	params: {
		name: 'proplan',
		user_uid: 'arthur-clay'
	},
	model: {
		watches: 10,
		seasts: 1
	}
} */

const initialState = {
	data: []
}

export default {
	state: Object.assign({}, initialState),
	getters: {
		getForm: state => params => {
			const jsonParams = JSON.stringify(params)
			return state.data.find(form => {
				return JSON.stringify(form.params) === jsonParams
			})
		}
	},
	mutations: {
		[mutations.ADD_FORM] (state, value) {
			state.data.push(value)
		},
		[mutations.DEL_FORM] (state, params) {
			const jsonParams = JSON.stringify(params)
			state.data = state.data.filter(form => {
				return JSON.stringify(form.params) !== jsonParams
			})
		},
		[mutations.CLEAR_FORMS] (state) {
			Object.assign(state, initialState)
		}
	},
	actions: {
		addForm ({ commit, getters }, { params, model }) {
			if (getters.getForm(params)) {
				commit(mutations.DEL_FORM, params)
			}
			commit(mutations.ADD_FORM, { params, model })
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/forms.js